export const Screens = {
  BUNDLE: 'bundle',
  COMMERCE: 'commerce',
  CONTENT: 'content',
  FREE: 'crm',
  MARKETING: 'marketing',
  HUBSPOT_FOR_MARKETERS: 'marketing-plus',
  DATA: 'data',
  SALES: 'sales',
  SERVICE: 'service',
  SMART_CRM: 'smart-crm',
  PLATFORM: 'suite',
  FLEX_SEATS_AND_CREDITS: 'flex-seats-and-credits',
  FSC_CONFIGURE: 'fsc-configure'
};
/* Real, navigable hub-page slugs only — used to render/highlight PublicSideNav
 * items and to parse the URL in getPageSlug. HSOC_V2 is a tracking-only screen
 * (the HSoC v2 page lives at "/", not a "/flex-seats-and-credits" route), so it's
 * excluded here even though it's a valid PublicNavItem. */
export const PUBLIC_NAV_ITEMS = [Screens.PLATFORM, Screens.FREE, Screens.BUNDLE, Screens.HUBSPOT_FOR_MARKETERS, Screens.SMART_CRM, Screens.MARKETING, Screens.SALES, Screens.SERVICE, Screens.CONTENT, Screens.DATA, Screens.COMMERCE];
const PUBLIC_NAV_ITEMS_SET = new Set(PUBLIC_NAV_ITEMS);
export function isPublicNavItem(s) {
  return PUBLIC_NAV_ITEMS_SET.has(s);
}